import { Inject, Injectable } from "@angular/core";
import { CommandHandlerFor, Http } from "@skylab-angular-shared/core";
import { KsefReceiveUpoCommand, KsefReceiveUpoCommandBase } from "@skylab-shared/business";
import { HttpService } from "@skylab-shared/core";

@Injectable({providedIn: 'root'})
@CommandHandlerFor(KsefReceiveUpoCommand)
export class KsefReceiveUpoCommandHandler {
    private commandHandler: KsefReceiveUpoCommandBase;
    public constructor(@Inject(Http)http: HttpService){
        this.commandHandler = new KsefReceiveUpoCommandBase(http);
    }
    public async handleAsync(query: KsefReceiveUpoCommand): Promise<any> {
        await this.commandHandler.handleAsync(query);
    }
}
